<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <slot></slot>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
              <section class="section">
                <h2 class="title">{{ $t('Datos de acceso') }}</h2>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Email Corporativo')">
                    <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <b-input
                        :disabled="mode != 'create'"
                        expanded
                        v-model="formData.email"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                  <b-field expanded :label="$t('Código de Invitación')">
                    <ValidationProvider
                      :disabled="mode != 'create'"
                      name="Código"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        v-model="formData.invitationCode"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field :label="$t('Es subpartner')">
                    <b-checkbox
                      :disabled="mode != 'create'"
                      v-model="formData.isSubpartner"
                    ></b-checkbox>
                  </b-field>
                  <b-field
                    v-if="formData.isSubpartner"
                    expanded
                    :label="$t('Email partner')"
                  >
                    <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <b-input
                        :disabled="mode != 'create'"
                        expanded
                        v-model="formData.partnerEmail"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                  <b-field v-else expanded :label="$t('Referencia')">
                    <ValidationProvider
                      name="Referencia"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input expanded v-model="formData.reference"></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
              </section>
              <section class="section">
                <h2 class="title">{{ $t('Datos de contacto') }}</h2>
                <p>
                  {{
                    $t(
                      'Los campos marcados con asterisco (*) son obligatorios.'
                    )
                  }}
                </p>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Nombre')">
                    <ValidationProvider
                      name="Name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input expanded v-model="formData.firstName"></b-input>
                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>

                  <b-field expanded :label="$t('Apellidos')">
                    <ValidationProvider
                      name="Surname"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input expanded v-model="formData.lastName"></b-input>
                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Profesión')">
                    <ValidationProvider
                      name="Profession"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        v-model="formData.jobPosition"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>

                  <b-field expanded :label="$t('Ciudad')">
                    <b-input expanded v-model="formData.city"></b-input>
                  </b-field>
                  <b-field expanded :label="$t('Idioma')">
                    <b-select
                      expanded
                      v-model="formData.lang"
                      :placeholder="$t('Selecciona')"
                    >
                      <option value="es">
                        ES
                      </option>
                      <option value="en">
                        EN
                      </option>
                      <option value="ar">
                        عربى
                      </option>
                      <option value="pt">
                        PT
                      </option>
                      <option value="fr">
                        FR
                      </option>
                      <option value="cn">
                        CN
                      </option>
                    </b-select>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Teléfono')">
                    <VuePhoneNumberInput v-model="formData.telephone" />
                  </b-field>

                  <b-field expanded :label="$t('País')">
                    <ValidationProvider
                      name="Country"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-input expanded v-model="formData.country"></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Tipo de subscripción')">
                    <b-select
                      expanded
                      v-model="formData.subscription"
                      :placeholder="$t('Selecciona')"
                    >
                      <option value="trial">
                        {{ $t('Periodo de prueba') }}
                      </option>
                      <option value="master">
                        {{ $t('Franquicia MASTER') }}
                      </option>
                      <option value="corner">
                        {{ $t('Franquicia CORNER') }}
                      </option>
                      <option value="premium">
                        {{ $t('Franquicia PREMIUM') }}
                      </option>
                      <option value="city">
                        {{ $t('Franquicia CITY') }}
                      </option>
                    </b-select>
                  </b-field>

                  <b-field expanded :label="$t('Acceso hasta')">
                    <ValidationProvider
                      name="Validez"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-datepicker
                        v-model="formData.expirationDate"
                        :show-week-number="false"
                        :date-parser="dateParser"
                        :date-formatter="dateFormatter"
                        :placeholder="$t('Haz click para seleccionar...')"
                        icon="calendar-today"
                        position="is-top-right"
                        trap-focus
                      ></b-datepicker>
                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
                <b-field grouped group-multiline>
                  <b-field expanded :label="$t('Red Social')">
                    <b-input
                      expanded
                      v-model="formData.socialNetwork"
                    ></b-input>
                  </b-field>

                  <b-field expanded label="Email">
                    <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <b-input
                        expanded
                        v-model="formData.contactEmail"
                      ></b-input>

                      <p v-show="errors.length" class="help is-danger">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                </b-field>
              </section>
              <section class="section">
                <h2 class="title">{{ $t('Ficha de usuario') }}</h2>
                <b-field expanded>
                  <b-checkbox v-model="formData.deposit">
                    {{ $t('deposito') }}
                  </b-checkbox>
                </b-field>
                <b-field expanded>
                  <b-checkbox v-model="formData.kycInformation">
                    {{ $t('informacion kyc') }}
                  </b-checkbox>
                </b-field>
                <b-field expanded>
                  <file-input
                    icon="upload"
                    :text="$t('kyc')"
                    v-model="formData.kyc"
                  />
                </b-field>
                <b-field expanded>
                  <b-checkbox v-model="formData.admissionsComittee">
                    {{ $t('comite de admisiones') }}
                  </b-checkbox>
                </b-field>
                <b-field expanded :label="$t('fecha de admision')">
                  <ValidationProvider
                    name="Validez"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-datepicker
                      v-model="formData.admissionDate"
                      :show-week-number="false"
                      :date-parser="dateParser"
                      :date-formatter="dateFormatter"
                      :placeholder="$t('Haz click para seleccionar...')"
                      icon="calendar-today"
                      position="is-top-right"
                      trap-focus
                    ></b-datepicker>
                    <p v-show="errors.length" class="help is-danger">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </b-field>
                <b-field expanded>
                  <b-checkbox v-model="formData.ndaDraft">
                    {{ $t('borrador nda') }}
                  </b-checkbox>
                </b-field>
                <b-field expanded>
                  <file-input
                    icon="upload"
                    :text="$t('nda firmado')"
                    v-model="formData.signedNDA"
                  />
                </b-field>
                <b-field expanded>
                  <b-checkbox v-model="formData.contractDraft">
                    {{ $t('borrador contrato') }}
                  </b-checkbox>
                </b-field>
                <b-field expanded>
                  <file-input
                    icon="upload"
                    :text="$t('contrato firmado')"
                    v-model="formData.signedContract"
                  />
                </b-field>
              </section>
              <div class="has-text-centered">
                <b-button
                  size="is-large"
                  native-type="submit"
                  type="is-primary"
                  >{{ $t('Enviar') }}</b-button
                >
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, numeric, email } from 'vee-validate/dist/rules'
import BulmaS3UploadInput from '@/components/common/BulmaS3UploadInputSingle'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
extend('required', {
  ...required
})

extend('numeric', {
  ...numeric
})

extend('email', {
  ...email
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePhoneNumberInput,
    FileInput: BulmaS3UploadInput
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    userData: {
      type: Object,
      default: function() {
        return {
          reference: null,
          firstName: null,
          lastName: null,
          subscription: null,
          expirationDate: null,
          jobPosition: null,
          city: null,
          lang: null,
          telephone: null,
          country: null,
          socialNetwork: null,
          contactEmail: null,
          invitationCode: null,
          email: null,
          deposit: false,
          admissionsComittee: false,
          kycInformation: false,
          ndaDraft: false,
          contractDraft: false,
          signedNDA: null,
          admissionDate: null,
          signedContract: null,
          kyc: null,
          isSubpartner: false,
          partnerEmail: null
        }
      }
    }
  },
  data() {
    return {
      formData: {
        reference: null,
        firstName: null,
        lastName: null,
        subscription: null,
        expirationDate: null,
        jobPosition: null,
        city: null,
        lang: null,
        telephone: null,
        country: null,
        socialNetwork: null,
        contactEmail: null,
        invitationCode: null,
        email: null,
        deposit: false,
        admissionsComittee: false,
        kycInformation: false,
        ndaDraft: false,
        contractDraft: false,
        signedNDA: null,
        admissionDate: null,
        signedContract: null,
        kyc: null,
        isSubpartner: false,
        partnerEmail: null
      }
    }
  },
  watch: {
    userData: {
      deep: true,
      handler(userData) {
        this.formData.isSubpartner = userData.isSubpartner
        this.formData.partnerEmail = userData.partnerEmail
        this.formData.firstName = userData.firstName
        this.formData.reference = userData.reference
        this.formData.lastName = userData.lastName
        this.formData.subscription = userData.subscription
        this.formData.expirationDate = moment(
          this.userData.expirationDate,
          'DD/MM/YYYY'
        ).toDate()
        this.formData.admissionDate = moment(
          this.userData.admissionDate,
          'DD/MM/YYYY'
        ).toDate()
        this.formData.jobPosition = this.userData.jobPosition
        this.formData.city = this.userData.city
        this.formData.lang = this.userData.lang
        this.formData.telephone = this.userData.telephone
        this.formData.country = this.userData.country
        this.formData.socialNetwork = this.userData.socialNetwork
        this.formData.contactEmail = this.userData.contactEmail
        this.formData.invitationCode = this.userData.invitationCode
        this.formData.email = this.userData.email
        this.formData.deposit = this.userData.deposit
        this.formData.admissionsComittee = this.userData.admissionsComittee
        this.formData.kyc = this.userData.kyc
        this.formData.kycInformation = this.userData.kycInformation
        this.formData.ndaDraft = this.userData.ndaDraft
        this.formData.contractDraft = this.userData.contractDraft
        this.formData.signedNDA = this.userData.signedNDA
        this.formData.signedContract = this.userData.signedContract
        this.formData.admissionDate = this.formData.admissionDate
          ? moment(this.formData.admissionDate).toDate()
          : moment()
              .add(7, 'days')
              .toDate()
        this.formData.expirationDate = this.formData.expirationDate
          ? moment(this.formData.expirationDate).toDate()
          : moment()
              .add(7, 'days')
              .toDate()
      }
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.formData.expirationDate = moment(
        this.formData.expirationDate
      ).format('DD/MM/YYYY')
      this.formData.admissionDate = moment(this.formData.admissionDate).format(
        'DD/MM/YYYY'
      )
      this.$emit('formSubmit', this.formData)
    },
    dateParser(date) {
      return moment(date).toDate()
    },
    dateFormatter(date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped></style>
